import AssignedByMeTaskFilters from "./filters";
import TasksListWrapper from "../components/tasks-list";

export default function AssignedByMeTasks({ status }) {
  return (
    <TasksListWrapper
      status={status}
      basePath="/tasks/assigned-by-me"
      storageKeyPrefix="assigned-by-me"
      baseFilters={{ user_created: { _eq: "$CURRENT_USER" } }}
      showAssigneeColumn={true}
      renderFilters={AssignedByMeTaskFilters}
    />
  );
}
